import {
  DateWindow,
  ReportFilters,
  toIsoDate,
} from './report-types';

export function resolveDateWindow(filters: ReportFilters): DateWindow {
  if (filters.datePreset === 'custom') {
    return {
      start: filters.startDate,
      end: filters.endDate,
    };
  }

  const now = new Date();

  if (filters.datePreset === 'previous_week') {
    const weekday = now.getDay();
    const daysSinceMonday = weekday === 0 ? 6 : weekday - 1;

    const startCurrentWeek = new Date(now);
    startCurrentWeek.setDate(now.getDate() - daysSinceMonday);

    const startPreviousWeek = new Date(startCurrentWeek);
    startPreviousWeek.setDate(startCurrentWeek.getDate() - 7);

    const endPreviousWeek = new Date(startCurrentWeek);
    endPreviousWeek.setDate(startCurrentWeek.getDate() - 1);

    return {
      start: toIsoDate(startPreviousWeek),
      end: toIsoDate(endPreviousWeek),
    };
  }

  if (filters.datePreset === 'previous_quarter') {
    const currentQuarter = Math.floor(now.getMonth() / 3);
    const previousQuarterStartMonth = currentQuarter === 0 ? 9 : (currentQuarter - 1) * 3;
    const previousQuarterYear = currentQuarter === 0 ? now.getFullYear() - 1 : now.getFullYear();
    const start = new Date(previousQuarterYear, previousQuarterStartMonth, 1);
    const end = new Date(previousQuarterYear, previousQuarterStartMonth + 3, 0);

    return {
      start: toIsoDate(start),
      end: toIsoDate(end),
    };
  }

  const firstDayCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstDayPreviousMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastDayPreviousMonth = new Date(firstDayCurrentMonth);
  lastDayPreviousMonth.setDate(0);

  return {
    start: toIsoDate(firstDayPreviousMonth),
    end: toIsoDate(lastDayPreviousMonth),
  };
}
